export default "__VITE_ASSET__d9a28668__"